var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "search-list" },
    [
      _vm.combineSearchResult.length && !_vm.isSearchResultNullForTaiwantrade
        ? [
            _c("div", { staticClass: "search-subtitle" }, [
              _vm._v("\n      " + _vm._s(_vm.$t("searchResult")) + "\n    "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "search-container" }, [
              _c(
                "div",
                { staticClass: "search-result-box" },
                [
                  _vm._l(_vm.combineSearchResult, function (item) {
                    return [
                      _c(
                        "div",
                        {
                          key:
                            item.markerId +
                            (item.objectId ? "-" + item.objectId : ""),
                        },
                        [
                          _vm.selectedCategory === _vm.CATEGORY_OPTIONS[0]
                            ? _c("div", { staticClass: "item-kind" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t(item.kind)) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "search-result-item" }, [
                            _c(
                              "div",
                              { staticClass: "item-image" },
                              [
                                item.kind === "product"
                                  ? [
                                      item.type === "gallery"
                                        ? _c("img", {
                                            attrs: { src: item.photo },
                                          })
                                        : item.type === "videoplay" &&
                                          item.videoplayAttribute.type ===
                                            "embed"
                                        ? _c("img", {
                                            attrs: {
                                              src: _vm.getEmbedVideoThumbnail(
                                                item.videoplayAttribute
                                              ),
                                            },
                                          })
                                        : _c("img", {
                                            attrs: {
                                              src: _vm.getMarkerProfile(item),
                                            },
                                          }),
                                    ]
                                  : item.kind === "company"
                                  ? [
                                      _c("img", {
                                        attrs: { src: item.logoUrl },
                                      }),
                                    ]
                                  : item.kind === "livetour"
                                  ? [
                                      _c("img", {
                                        attrs: { src: item.thumbnail },
                                      }),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "item-info" }, [
                              _c("div", { staticClass: "full-width" }, [
                                _c("h3", { staticClass: "item-name" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        item.nameMulti[_vm.lang] || item.name
                                      ) +
                                      "\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "full-width limit-line item-description",
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          item.descriptionMulti[_vm.lang] ||
                                            item.description
                                        ) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "item-tags" },
                                [
                                  _c("i-tag-list", {
                                    attrs: { tags: _vm.getCategory(item) },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "item-aciton-box" },
                              [
                                _vm.isFavoritesAvailable(item)
                                  ? _c("i-favorite", {
                                      attrs: {
                                        category: _vm.getItemCategory(
                                          item.kind
                                        ),
                                        item: item.raw,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ title, onClick }) {
                                              return [
                                                _c(
                                                  "button",
                                                  { on: { click: onClick } },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(title) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    })
                                  : _c("span"),
                                _vm._v(" "),
                                item.kind === "product"
                                  ? [
                                      _c(
                                        "button",
                                        {
                                          staticStyle: { "margin-top": "1rem" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$emit(
                                                "gotoTarget",
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("cardMore")) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : item.kind === "company"
                                  ? [
                                      _c(
                                        "button",
                                        {
                                          staticStyle: { "margin-top": "1rem" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.popupCompanyModal(item)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("cardMore")) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : item.kind === "livetour"
                                  ? [
                                      _c(
                                        "button",
                                        {
                                          staticStyle: { "margin-top": "1rem" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$emit(
                                                "gotoTarget",
                                                {
                                                  buildingId: item.objectId,
                                                  panoramaId:
                                                    item.panoramas[0].objectId,
                                                },
                                                false
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("cardMore")) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.combineRelatedResult.length
        ? [
            _c("div", { staticClass: "search-subtitle" }, [
              _vm._v("\n      " + _vm._s(_vm.$t("relatedResult")) + "\n    "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "search-container" }, [
              _c(
                "div",
                { staticClass: "search-result-box" },
                [
                  _vm._l(_vm.combineRelatedResult, function (item) {
                    return [
                      _c(
                        "div",
                        {
                          key:
                            item.markerId +
                            (item.objectId ? "-" + item.objectId : ""),
                        },
                        [
                          _vm.selectedCategory === _vm.CATEGORY_OPTIONS[0]
                            ? _c("div", { staticClass: "item-kind" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t(item.kind)) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "search-result-item" }, [
                            _c(
                              "div",
                              { staticClass: "item-image" },
                              [
                                item.kind === "product"
                                  ? [
                                      item.type !== "gallery"
                                        ? _c("img", {
                                            attrs: {
                                              src: _vm.getMarkerProfile(item),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.type === "gallery"
                                        ? _c("img", {
                                            attrs: { src: item.photo },
                                          })
                                        : _vm._e(),
                                    ]
                                  : item.kind === "company"
                                  ? [
                                      _c("img", {
                                        attrs: { src: item.logoUrl },
                                      }),
                                    ]
                                  : item.kind === "livetour"
                                  ? [
                                      _c("img", {
                                        attrs: { src: item.thumbnail },
                                      }),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "item-info" }, [
                              _c("div", { staticClass: "full-width" }, [
                                _c("h3", { staticClass: "item-name" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        item.nameMulti[_vm.lang] || item.name
                                      ) +
                                      "\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "full-width limit-line item-description",
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          item.descriptionMulti[_vm.lang] ||
                                            item.description
                                        ) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "item-tags" },
                                [
                                  _c("i-tag-list", {
                                    attrs: { tags: _vm.getCategory(item) },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "item-aciton-box" },
                              [
                                _vm.isFavoritesAvailable(item)
                                  ? _c("i-favorite", {
                                      attrs: {
                                        category: _vm.getItemCategory(
                                          item.kind
                                        ),
                                        item: item.raw,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ title, onClick }) {
                                              return [
                                                _c(
                                                  "button",
                                                  { on: { click: onClick } },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(title) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                item.kind === "product"
                                  ? [
                                      _c(
                                        "button",
                                        {
                                          staticStyle: { "margin-top": "1rem" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$emit(
                                                "gotoTarget",
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("cardMore")) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : item.kind === "company"
                                  ? [
                                      _c(
                                        "button",
                                        {
                                          staticStyle: { "margin-top": "1rem" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.popupCompanyModal(item)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("cardMore")) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : item.kind === "livetour"
                                  ? [
                                      _c(
                                        "button",
                                        {
                                          staticStyle: { "margin-top": "1rem" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.gotoBuilding(item)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("cardMore")) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.combineSearchResult.length === 0 &&
      _vm.combineRelatedResult.length === 0
        ? _c("div", { staticClass: "no-result-box" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("noSearchResult")))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "i-modal",
        {
          ref: "company-modal",
          attrs: { bgcolor: "rgba(0,0,0,0.7)", closeable: "" },
          on: {
            closed: function ($event) {
              _vm.currentCompany = {}
            },
          },
        },
        [
          _c("div", { staticClass: "company-info" }, [
            _c("div", { staticClass: "company-header" }, [
              _c("div", { staticClass: "company-detail" }, [
                _c(
                  "div",
                  { staticClass: "company-action" },
                  [
                    _c("h3", [_vm._v(_vm._s(_vm.currentCompany.name))]),
                    _vm._v(" "),
                    _c("i-favorite", {
                      attrs: { category: "user", item: _vm.currentCompany.raw },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ title, onClick }) {
                            return [
                              _c("button", { on: { click: onClick } }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(title) +
                                    "\n                "
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "desktop-tag-list" },
                  [
                    _c("i-tag-list", {
                      attrs: { tags: _vm.getCategory(_vm.currentCompany) },
                      on: { click: _vm.closeCompanyModal },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "company-logo" }, [
                _c("img", { attrs: { src: _vm.currentCompany.logoUrl } }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mobile-tag-list" },
                [
                  _c("i-tag-list", {
                    attrs: { tags: _vm.getCategory(_vm.currentCompany) },
                    on: { click: _vm.closeCompanyModal },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "company-body" }, [
              _c("p", { staticClass: "company-description" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.currentCompany.description) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "company-buildings",
                class: [
                  _vm.currentCompanyBuildings.length >= 3
                    ? "company-buildings-more"
                    : "company-buildings-less",
                ],
              },
              [
                _vm._l(_vm.currentCompanyBuildings, function (building) {
                  return [
                    _c(
                      "div",
                      { key: "a" + building.objectId, staticClass: "building" },
                      [
                        _c("div", { staticClass: "building-img" }, [
                          _c("img", {
                            attrs: {
                              src: building.thumbnail,
                              alt: building.name,
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("h3", { staticClass: "building-name" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(building.name) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "building-description" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(building.description) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "building-action" }, [
                          _c(
                            "button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.gotoBuilding(building)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("clickNavigate")) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]
                }),
              ],
              2
            ),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }